var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBoardView = function SvgBoardView(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 22,
    viewBox: "0 0 21.6 21.6",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.55 0h1.8A2.55 2.55 0 0 1 6.9 2.55v16.5a2.55 2.55 0 0 1-2.55 2.55h-1.8A2.55 2.55 0 0 1 0 19.05V2.55A2.55 2.55 0 0 1 2.55 0m0 1.5h1.8A1.05 1.05 0 0 1 5.4 2.55v16.5a1.05 1.05 0 0 1-1.05 1.05h-1.8a1.05 1.05 0 0 1-1.05-1.05V2.55A1.05 1.05 0 0 1 2.55 1.5M9.9 0h1.8a2.55 2.55 0 0 1 2.55 2.55v9.9A2.55 2.55 0 0 1 11.7 15H9.9a2.55 2.55 0 0 1-2.55-2.55v-9.9A2.55 2.55 0 0 1 9.9 0m0 1.5h1.8a1.05 1.05 0 0 1 1.05 1.05v9.9a1.05 1.05 0 0 1-1.05 1.05H9.9a1.05 1.05 0 0 1-1.05-1.05v-9.9A1.05 1.05 0 0 1 9.9 1.5M17.25 0h1.8a2.55 2.55 0 0 1 2.55 2.55v13.2a2.55 2.55 0 0 1-2.55 2.55h-1.8a2.55 2.55 0 0 1-2.55-2.55V2.55A2.55 2.55 0 0 1 17.25 0m0 1.5h1.8a1.05 1.05 0 0 1 1.05 1.05v13.2a1.05 1.05 0 0 1-1.05 1.05h-1.8a1.05 1.05 0 0 1-1.05-1.05V2.55a1.05 1.05 0 0 1 1.05-1.05",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBoardView);
export default ForwardRef;